import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { EmblemDivider } from './Emblem';
const reviews = [{
  name: 'Margaret D.',
  relationship: 'Customer since 1998',
  rating: 5,
  text: "I brought my mother's engagement ring in to be remodelled after she passed. James spent over an hour with me before I'd committed to anything, and what he made from the original stones brings me to tears every time I look at it. There is no one else I would trust with anything sentimental.",
  service: 'Heirloom remodelling'
}, {
  name: 'James W.',
  relationship: 'Engagement ring · 2023',
  rating: 5,
  text: "I walked in knowing nothing and terrified of overspending. The team showed me three diamonds within my budget, explained exactly what I was looking at, and built me a ring that came in $1,400 under what I'd seen at a chain store — for a stone two grades higher. She still hasn't stopped looking at it.",
  service: 'Custom engagement ring'
}, {
  name: 'David L.',
  relationship: 'Customer since 1999',
  rating: 5,
  text: "Twenty-five years of repairs, sizings, anniversary pieces and one disastrous insurance claim where they re-made a lost ring better than the original. They've never once made me feel like a small customer. The kind of jeweller you don't realise still exists.",
  service: 'Repairs & restoration'
}, {
  name: 'Emma T.',
  relationship: 'Wedding bands · 2024',
  rating: 5,
  text: 'We saw the CAD model, then the resin proof, then the finished rings. At no point were we surprised, rushed, or pushed into upgrades. When my fiancé picked up his ring he actually got a little emotional. Worth every dollar — and we got change from what the chain stores quoted.',
  service: 'Bridal jewellery'
}];
export function Reviews() {
  return <section className="section-padding paper-texture border-y border-gold/15" data-id="element-569">
      <div className="container-custom" data-id="element-570">
        <div className="max-w-4xl mb-12" data-id="element-571">
          <span className="eyebrow" data-id="element-572">In their own words</span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium leading-[1.1] mb-6 text-balance" data-id="element-573">
            Some of our customers have been with us{' '}
            <span className="italic text-gold-dark" data-id="element-574">for half their lives.</span>
          </h2>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2" data-id="element-575">
            <div className="flex items-center gap-1" data-id="element-576">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-577" />)}
              <span className="ml-2 text-sm text-primary font-medium" data-id="element-578">
                5.0 average across Google
              </span>
            </div>
            <span className="text-xs text-muted" data-id="element-579">
              Live reviews to be embedded via Google widget
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-580">
          {reviews.map((review, index) => <motion.article key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="relative bg-surface p-8 md:p-10 border border-gold/15 flex flex-col" data-id="element-581">
              <QuoteIcon className="absolute top-6 right-6 w-8 h-8 text-gold/15" strokeWidth={1} data-id="element-582" />

              <div className="flex gap-1 mb-5" data-id="element-583">
                {[...Array(review.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-gold fill-gold" data-id="element-584" />)}
              </div>

              <blockquote className="font-serif text-lg md:text-xl text-primary leading-snug mb-8 text-pretty flex-grow" data-id="element-585">
                "{review.text}"
              </blockquote>

              <footer className="pt-5 border-t border-gold/10 flex items-center justify-between" data-id="element-586">
                <div data-id="element-587">
                  <p className="font-medium text-sm text-primary" data-id="element-588">
                    {review.name}
                  </p>
                  <p className="text-xs text-muted mt-1" data-id="element-589">
                    {review.relationship}
                  </p>
                </div>
                <div className="text-right" data-id="element-590">
                  <p className="brand-mark text-[0.6rem] text-gold-dark uppercase" data-id="element-591">
                    {review.service}
                  </p>
                  <p className="text-[0.6rem] tracking-wider uppercase text-muted mt-1" data-id="element-592">
                    via Google
                  </p>
                </div>
              </footer>
            </motion.article>)}
        </div>

        <EmblemDivider className="mt-14" data-id="element-593" />

        <p className="text-xs text-muted text-center mt-6 italic max-w-2xl mx-auto" data-id="element-594">
          Excerpts shown — replace with live Google reviews widget at Bricks
          build. [VERIFY every review with client before publishing.]
        </p>
      </div>
    </section>;
}